<app-modal-header [modalTitle]="modalTitle" [showCloseBtn]="false"></app-modal-header>
<!-- Modal Content -->
<div class="modal-content" [attr.loading]="false" [attr.size]="'small'">
    <section class="primary-section-container">
        <div *ngIf="!hasData" class="no-data-message">No On Hand / On Order data was uploaded for this row.</div>

        <div *ngIf="committed" class="oh-oo-table-wrapper">
            <table class="oh-oo-table">
                <caption>
                    Committed (submitted per store &mdash; shown for this store)
                </caption>
                <thead>
                    <tr>
                        <th *ngFor="let size of sizes">{{ size }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td *ngFor="let size of sizes">{{ committed[size] ?? '--' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div *ngIf="uncommitted" class="oh-oo-table-wrapper">
            <table class="oh-oo-table oh-oo-table--uncommitted">
                <caption>
                    Uncommitted (submitted per job/DC, not per store &mdash; same for every store in this job)
                </caption>
                <thead>
                    <tr>
                        <th>DC ID</th>
                        <th *ngFor="let size of sizes">{{ size }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let dcRow of uncommitted">
                        <td>{{ dcRow.dc_id }}</td>
                        <td *ngFor="let size of sizes">{{ dcRow[size] ?? '--' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>
</div>
<!-- Modal Footer -->
<app-modal-footer (closeModal)="close()" [closeBtnText]="'Close'" [showUpdateBtn]="false"></app-modal-footer>
